import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IOTP } from '../OTP';

export function useSubmitOTPForValidation(patientId?: number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<IOTP, AppMedError, number>({
        mutationKey: [QueryKeys.otp, 'submit'],
        mutationFn: async (id: number) => {
            return await OTPApi.submitOTPForValidation(id);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otp] });
            if (patientId) 
                queryClient.invalidateQueries({ queryKey: [QueryKeys.otpByPatient, patientId] });
            
            notifications.show({
                title: t('otp.notifications.submitSuccess.title'),
                message: t('otp.notifications.submitSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.submitError.title'),
                message: error?.message || t('otp.notifications.submitError.message'),
                color: 'red',
            });
        },
    });
}
